// vendorTypeLabels.ts — what a vendor_type key is CALLED, when the API has not
// told us.
//
// The taxonomy is a table an admin manages (migration 063), and
// GET /procurement/vendors ships it as `types: { key, label, sort_order }[]`,
// active ones in order. That payload is the source of every label on screen.
//
// THERE USED TO BE A HARDCODED MAP HERE and it had to go, not for tidiness: it
// would have kept serving the OLD name after a rename. An admin renaming "PCBA"
// to "Bare boards" would see the new name on the admin page and the old one on
// every vendor row, with nothing to explain the difference. A stale label is
// worse than a plain one.
//
// So what is left is the fallback for a key the payload does not carry, which
// happens for exactly one reason: a retired type still attached to an older
// vendor. Title-casing the key keeps that row readable instead of blank.
//
// This is a leaf module on purpose. VendorsAdmin.tsx opens VendorPreviewModal
// (its row-click preview) and both need this, so both importing from here keeps
// the dependency graph a DAG. VendorsAdmin re-exports formatType, so the older
// import path through it still resolves.

/** One entry of the taxonomy, as the API sends it. */
export interface VendorTypeOption {
  key: string;
  label: string;
  sort_order: number;
}

/**
 * A readable name for a key the payload did not carry. Never call this when the
 * payload has a label for the key: the label is what a person chose, and this is
 * only a guess made from the key's spelling.
 */
export const formatType = (type: string): string =>
  (type || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
